import styled, { css } from 'styled-components'
import { ThemeSelectors, TypePrius, TypeSmart } from '@at/design-system-foundation'
import { BREAKPOINTS } from '@at/window-utils/lib/responsive-utils/match-media.util'
import { Button, Input } from '@at/design-system-elements'
import { rgba } from 'polished'

export const StyledSearchFiltersByKeywords = styled.section`
    padding: ${({ theme }) => ThemeSelectors.getGridUnit(theme)} 0;
    width: 100%;
`

export const StyledSearchFiltersByKeywordsRow = styled.div`
    ${({ theme }) => {
        return css`
            & > button {
                &:hover {
                    cursor: pointer;
                }
                background-color: transparent;
                padding: ${ThemeSelectors.getGridUnit(theme)} 0px;
            }
            display: flex;

            justify-content: space-between;
            margin: ${ThemeSelectors.getGridUnit(theme)} 0 ${ThemeSelectors.getLegacyGridUnit(theme) * 2}px;
            height: fit-content;
            align-items: center;
            margin-top: -8px;
        `
    }}
`

export const StyledButton = styled(Button)`
    ${({ theme }) => {
        return css`
            height: 54px;
            margin-top: auto;
            margin-bottom: 4px;
            margin-left: ${ThemeSelectors.getGroupTwoSpacing(theme)};
            width: auto;
        `
    }}
`

export const StyledSearchFiltersByKeywordsInput = styled(Input)`
    ${({ theme }) => {
        return css`
            border-color: ${theme.color.border.default};
            color: ${theme.color.text.input};
            font-size: 16px;
            line-height: 30px;
            padding: 4px 0;
            border-radius: 2px;

            width: 100%;
            margin-right: ${ThemeSelectors.getGridUnit(theme)};

            & > label {
                color: ${({ theme }) => theme.color.text.default};
            }

            & div > input {
                height: 54px;
                margin-top: 4px;
                border: 1px solid ${({ theme }) => theme.color.border.default};
            }

            &:focus,
            &:active {
                outline: 0;
            }
            &:disabled {
                opacity: 0.3;
            }
        `
    }}
`

export const StyledSearchFiltersByKeywordsSelectedContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin: 0 0 ${({ theme }) => ThemeSelectors.getGridUnit(theme)};
    height: fit-content;
    align-items: center;
`

export const StyledSearchFiltersByKeywordsSelectedButton = styled(TypePrius)`
    ${({ theme }) => {
        return css`
            @keyframes fadeIn {
                from {
                    opacity: 0;
                }
                to {
                    opacity: 1;
                }
            }
            &:hover {
                cursor: pointer;
                color: ${theme.color.text.input};
            }
            & span {
                display: block;
                margin: 0 ${ThemeSelectors.getLegacyGridUnit(theme) * 0.5}px;
            }
            & span > svg {
                width: 10px;
                height: 14px;
            }
            align-items: center;
            animation: fadeIn 0.1s;
            background-color: ${({ theme }) => rgba(theme.color.button.bgFill.primary.default, 0.05)};
            border-radius: 3em;
            border: 0;
            color: ${theme.color.button.text.plain.default};
            display: flex;
            font-size: 14px;
            height: 36px;
            margin: ${ThemeSelectors.getLegacyGridUnit(theme)}px ${ThemeSelectors.getLegacyGridUnit(theme)}px
                ${ThemeSelectors.getLegacyGridUnit(theme)}px 0;
            padding: 0 ${ThemeSelectors.getGridUnit(theme)};
            svg {
                path {
                    fill: currentColor;
                }
            }
        `
    }}
`

export const StyledTextKeyword = styled(TypeSmart)`
    @media (max-width: ${BREAKPOINTS.MEDIUM}px) {
        max-width: 210px;
    }
    font-size: 14px;
    line-height: 1.1;
    max-width: 250px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-variation-settings: 'wght' 500;
`
